import { useMediaQuery } from 'react-responsive';
import { isWeb } from './device';
import { screenWidth } from './dimensions';
// Breakpoints
const desktopBreakpoint = 1223;
const tabletBreakpoint = 1023;
const mobileBreakpoint = 767;
const mobileSmallBreakpoint = 350;
// Native Resposive
const isDesktopNative = screenWidth > desktopBreakpoint;
const isLaptopOrDesktopNative = screenWidth > tabletBreakpoint + 1;
const isLaptopNative = screenWidth > tabletBreakpoint + 1 && screenWidth < desktopBreakpoint;
const isTabletNative = screenWidth < tabletBreakpoint && screenWidth > mobileBreakpoint + 1;
const isTabletOrMobileNative = screenWidth < tabletBreakpoint;
const isMobileNative = screenWidth < mobileBreakpoint;
const isNotMobleNative = screenWidth > mobileBreakpoint;
const isMobileSmallNative = screenWidth < mobileSmallBreakpoint;
// Cross-Platform Responsive Components
const Desktop = ({ children }) => {
    const isDesktop = isWeb
        ? useMediaQuery({ minWidth: desktopBreakpoint })
        : isDesktopNative;
    return isDesktop ? children : null;
};
const LaptopOrDesktop = ({ children }) => {
    const isDesktop = isWeb
        ? useMediaQuery({ minWidth: tabletBreakpoint + 1 })
        : isLaptopOrDesktopNative;
    return isDesktop ? children : null;
};
const Laptop = ({ children }) => {
    const isDesktop = isWeb
        ? useMediaQuery({
            minWidth: tabletBreakpoint + 1,
            maxWidth: desktopBreakpoint,
        })
        : isLaptopNative;
    return isDesktop ? children : null;
};
const Tablet = ({ children }) => {
    const isTablet = isWeb
        ? useMediaQuery({
            minWidth: mobileBreakpoint + 1,
            maxWidth: tabletBreakpoint,
        })
        : isTabletNative;
    return isTablet ? children : null;
};
const TabletOrMobile = ({ children }) => {
    const isTablet = isWeb
        ? useMediaQuery({
            maxWidth: tabletBreakpoint,
        })
        : isTabletOrMobileNative;
    return isTablet ? children : null;
};
const Mobile = ({ children }) => {
    const isMobile = isWeb
        ? useMediaQuery({ maxWidth: mobileBreakpoint })
        : isMobileNative;
    return isMobile ? children : null;
};
const NotMobile = ({ children }) => {
    const isMobile = isWeb
        ? useMediaQuery({ minWidth: mobileBreakpoint })
        : isNotMobleNative;
    return isMobile ? children : null;
};
const MobileSmall = ({ children }) => {
    const isMobile = isWeb
        ? useMediaQuery({ maxWidth: mobileSmallBreakpoint })
        : isMobileSmallNative;
    return isMobile ? children : null;
};
// Web Responsive Component
const HideSmall = ({ children }) => {
    const showElement = useMediaQuery({ minWidth: mobileBreakpoint });
    return showElement ? children : null;
};
const HideMedium = ({ children }) => {
    const showElement = useMediaQuery({ minWidth: tabletBreakpoint });
    return showElement ? children : null;
};
const ShowMedium = ({ children }) => {
    const showElement = useMediaQuery({ maxWidth: tabletBreakpoint });
    return showElement ? children : null;
};
const CustomHide = ({ children, minWidth = 0, maxWidth = 0 }) => {
    let showElement = true;
    const maxWidthPassed = useMediaQuery({ maxWidth: maxWidth });
    const minWidthPassed = useMediaQuery({ minWidth: minWidth });
    if (minWidth) {
        showElement = minWidthPassed;
    }
    if (showElement && maxWidth) {
        showElement = maxWidthPassed;
    }
    return showElement ? children : null;
};
export default {
    mobileBreakpoint,
    tabletBreakpoint,
    desktopBreakpoint,
    mobileSmallBreakpoint,
    isDesktopNative,
    isLaptopOrDesktopNative,
    isLaptopNative,
    isTabletNative,
    isTabletOrMobileNative,
    isMobileNative,
    isNotMobleNative,
    isMobileSmallNative,
    Desktop,
    LaptopOrDesktop,
    Laptop,
    Tablet,
    TabletOrMobile,
    Mobile,
    NotMobile,
    MobileSmall,
    HideSmall,
    HideMedium,
    ShowMedium,
    CustomHide,
};
//# sourceMappingURL=responsive.js.map